import { cx } from '@linaria/core';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import type { ReactEventHandler } from 'react';

import { emptyPlaceholder } from '~constants/images';
import type { TMedia } from '~constants/media';
import {
	buildFullUrl,
	getSrcString,
	onImageLoadError,
	pickImageByType,
} from '~utils/images';

import { blurredImage, loadedImage, Root } from './styles';

export interface BlurUpImageProps extends Omit<ImageProps, 'src'> {
	src?: ImageProps['src'];
	media?: TMedia[];
	blurSrc?: string;
	fallback?: string;
	preview?: boolean;
}

const handleLoad: ReactEventHandler<HTMLImageElement> = (e) => {
	(e.target as HTMLImageElement).classList.add('v');
};

export const BlurUpImage = ({
	className,
	src: srcProp,
	loader: loaderProp,
	blurSrc,
	media,
	fallback,
	preview,
	alt,
	width,
	height,
	onLoad,
	...props
}: BlurUpImageProps) => {
	const {
		src = emptyPlaceholder,
		previewSrc = src,
		loader = loaderProp,
	} = media
		? pickImageByType(media, { width, height }, fallback, preview)
		: {
				src: srcProp || (fallback && buildFullUrl(fallback)),
				previewSrc: blurSrc,
		  };
	const key = getSrcString(src);

	return (
		<Root>
			<Image
				key={`${key}blured`}
				className={cx(className, blurredImage)}
				src={previewSrc}
				loader={loader}
				alt={alt}
				{...props}
				width={10}
				height={10}
				quality={45}
			/>
			<Image
				key={key}
				className={cx(className, loadedImage)}
				src={src}
				loader={loader}
				width={width}
				height={height}
				alt={alt}
				onError={onImageLoadError}
				{...props}
				onLoad={(e) => {
					onLoad?.(e);
					handleLoad(e);
				}}
			/>
		</Root>
	);
};
